export default "__VITE_ASSET__S03SOEOq__"